/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Poll-composer overlay. Mounts the Figma-faithful "Create Poll" modal
// (3466:9979 / 10106 — see CreatePollModal) inside a transparent
// full-screen RN <Modal> so the dimmed scrim + centered card show
// correctly. The modal chrome is platform-agnostic; both web and
// desktop hosts pass their own `onSubmitDraft` callback that wires into
// their send pipelines (MessagingClient.send via the chat-room VM).

import type React from "react";
import { Modal as RNModal } from "react-native";

import { CreatePollModal } from "./CreatePollModal";
import type { PollComposerScreenSubmitPayload } from "./legacy";
import type { ChatRoomShellViewModel } from "../chat/useChatRoomShellViewModel";

export interface PollComposerOverlayProps {
	readonly vm: ChatRoomShellViewModel;
	readonly onSubmitDraft: (
		payload: PollComposerScreenSubmitPayload,
	) => Promise<void> | void;
}

export const PollComposerOverlay: React.FC<PollComposerOverlayProps> = ({
	vm,
	onSubmitDraft,
}) => {
	const isOpen = vm.state.activeOverlays.includes("pollComposer");

	const handleCancel = (): void => {
		vm.handlers.closeOverlay("pollComposer");
	};

	const handleSubmit = async (
		payload: PollComposerScreenSubmitPayload,
	): Promise<void> => {
		await onSubmitDraft(payload);
		vm.handlers.closeOverlay("pollComposer");
	};

	return (
		<RNModal
			visible={isOpen}
			transparent
			animationType="fade"
			onRequestClose={handleCancel}
			accessibilityViewIsModal
		>
			<CreatePollModal onCancel={handleCancel} onSubmit={handleSubmit} />
		</RNModal>
	);
};
